import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/auth/me`).then(res => {
        if (res.data.is_admin) navigate('/admin/dashboard');
      }).catch(() => {});
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('token', res.data.access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`;
      const userRes = await axios.get(`${API}/auth/me`);
      if (!userRes.data.is_admin) { setError('Not an admin account'); localStorage.removeItem('token'); return; }
      navigate('/admin/dashboard');
    } catch (err) { setError(err.response?.data?.detail || 'Login failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a0e27] flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-red-500/20 border border-red-500/30 flex items-center justify-center">
            <svg className="w-6 h-6 text-red-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" /></svg>
          </div>
          <h1 className="text-2xl font-extrabold text-white tracking-tight">Admin Access</h1>
          <p className="text-white/40 text-xs mt-1">Restricted area</p>
        </div>

        <div className="bg-white/5 rounded-2xl border border-white/10 p-6" data-testid="admin-login-form">
          {error && (
            <div className="bg-red-500/10 text-red-400 border border-red-500/20 rounded-lg px-4 py-3 mb-4 text-sm font-bold" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-[10px] font-bold text-white/50 mb-1.5 uppercase tracking-wider">Admin Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                placeholder="admin@..." required data-testid="admin-email-input" />
            </div>
            <div>
              <label className="block text-[10px] font-bold text-white/50 mb-1.5 uppercase tracking-wider">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                placeholder="Password" required data-testid="admin-password-input" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full py-3.5 bg-red-500 hover:bg-red-600 text-white font-extrabold rounded-xl transition-all disabled:opacity-50 text-sm"
              data-testid="admin-login-submit">
              {loading ? 'Authenticating...' : 'ACCESS ADMIN PANEL'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
